'use strict';

module.exports = callbackQueuePromise;

/**
 * Access a bootscript API via a promise rather than its callback queue directly.
 *
 * @param {string} queueName The name of the queue associated with the desired API.
 * @returns {Promise} A native Promise for the API.
 */
function callbackQueuePromise(queueName) {
    var queue = getQueue(queueName);
    return new Promise(function (resolve, reject) {
        queue.push(function () {
            resolve(this);
        });
    });
}

function getQueue(name) {
    /* global window */
    window[name] = window[name] || [];
    return window[name];
}
